// extracted by mini-css-extract-plugin
export default {"tab":"Organization_tab__mGH-U","tabName":"Organization_tabName__BLc0w","tabCount":"Organization_tabCount__7vRa+"};